import { createModel } from "@rematch/core";
import {
  AgeGroupType,
  ComplaintType,
  CustomerGroupFilterState,
  CustomerType,
  TernaryFilterOption,
} from "src/types";

import { RootModel } from ".";

export const initialState: CustomerGroupFilterState = {
  activeChurnedType: false,
  ageGroupType: AgeGroupType.ALL,
  complaintType: ComplaintType.WITHOUT,
  customerAddressPostalCodes: [],
  customerDuration: [0, 10],
  customerType: [CustomerType.PK],
  electricityFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    areaTypeFilter: null,
    supplyTypeFilter: null,
    tariffs: [],
    productFamilies: [],
  },
  gasFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    areaTypeFilter: null,
    supplyTypeFilter: null,
    productFamilies: [],
    tariffs: [],
  },
  heatingFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    productFamilies: [],
    tariffs: [],
  },
  glassFiberFilter: {
    contractExistingFilter: TernaryFilterOption.DISREGARD,
    productFamilies: [],
    tariffs: [],
  },
  maxChurn: 10,
  maxChurnDelta: 9,
  maxClv: 10,
  minChurn: 1,
  minChurnDelta: -9,
  minClv: 0,
  nextBestActivityFilter: [],
  polygonMapSelection: [],
  salutation: "Alle",
  housingSituationsFilter: {
    buildingTypes: [],
    buildingAges: [],
  },
  optIn: {
    phone: TernaryFilterOption.DISREGARD,
    mail: TernaryFilterOption.DISREGARD,
    email: TernaryFilterOption.DISREGARD,
  },
  phone: TernaryFilterOption.DISREGARD,
  email: TernaryFilterOption.DISREGARD,
  filterGroupsEnabled: {
    electricity: false,
    gas: false,
    heating: false,
    glassFiber: false,
    nextBestActivity: false,
    customerValueAnalysis: false,
    customerInformation: false,
    customerContactChannels: false,
    housingSituations: false,
  },
};

export const customerGroupFilter = createModel<RootModel>()({
  state: initialState,
  reducers: {
    changeCustomerGroupFilter(
      state,
      payload: Partial<CustomerGroupFilterState>
    ) {
      return { ...state, ...payload };
    },
    resetCustomerGroupFilter() {
      return initialState;
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/customerGroupFilter.ts